export default __webpack_public_path__ + "static/media/folder-delete.309794a9.svg";